export var gql_products = 'https://randomramblingpress.se/service/graphql/'; // 'http://localhost:4000/';

export var product_image_path =
  'https://randomramblingpress.se/images/products/';
